// @flow
import React from 'react';
import { colors } from '@peachjar/components';

import {
  TERMS_AND_CONDITIONS_URL,
  PRIVACY_POLICY_URL,
} from '../../../constants';

const { jungle } = colors;

type Props = {|
  styles: { [key: string]: string },
|};

const RegistrationFormDisclaimer = ({ styles }: Props) => (
  <p style={styles}>
    By creating an account, I agree to Peachjar&apos;s{' '}
    <a
      style={{
        color: jungle,
        textDecoration: 'none',
      }}
      href={TERMS_AND_CONDITIONS_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms of Service
    </a>{' '}
    and{' '}
    <a
      style={{
        color: jungle,
        textDecoration: 'none',
      }}
      href={PRIVACY_POLICY_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>.
  </p>
);

export default RegistrationFormDisclaimer;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/UserRegistration/components/RegistrationFormDisclaimer.jsx